import * as fetch from '../fetch'

let RemoveNull = (obj)=>{
	for(let key in obj){
		if(obj[key] === null || obj[key] === undefined || obj[key] === ""){
			delete obj[key];
		}
	}
	return obj;
};

export function get_feedback_list(data){
	return fetch.main_public_fetch({
		url: '/feedback',
		method: 'get',
		params: data,
	})
}

export function create_feedback(data){
	return fetch.main_public_fetch({
		url: '/feedback',
		method: 'post',
		data: RemoveNull(data),
	})
}
